<template>
	<div style="display: inline;">
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt"  getUrl="/web/basic/material/page" getKey="rows"
			:columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('wuliaobianma')">
						<el-input v-model="yt.conditions.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('wuliaomingcheng')">
						<el-input v-model="yt.conditions.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('jibenfenlei')">
						<yi_dictionary_select :type="'CUSTOMER_MATERIAL_TYPE'" :ids.sync="yt.conditions.type">
						</yi_dictionary_select>
					</el-form-item>
					<el-form-item>
						<el-button  @click="yt.get(1)" type="primary"
							plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button  @click="yt.clear()">{{$t('chongzhi')}}
						</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>

			<!-- 左侧按钮插槽 -->
			<!-- <template #buttonsL="scope">
				<el-button size="mini" icon="yicon yicon-add_fill" @click="yt.showEditDialog('xinzeng',null,'w1')" type="primary">
					{{$t('tianjawuliao')}}
				</el-button>
			</template> -->
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" :loading="yt.editObj.loading" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/basic/material/property/delete')">{{$t('shanchu')}}
						</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>
	</div>
</template>

<script type="text/javascript">
	export default {
		name: 'web_base_matter_matter_edit',
		data() {
			return {
				columns: [{
					lable: '#',
					type:'index'
				},{
					label: 'wuliaobianma',
					prop: 'code',
					width: 130
				}, {
					label: 'wuliaomingcheng',
					prop: 'name',
					width: 130
				}, {
					label: 'jibenfenlei',
					prop: 'type',
					type: 'dictionary',
					key: 'CUSTOMER_MATERIAL_TYPE'
				}, {
					label: 'guige',
					prop: 'spec'
				}, {
					label: 'dangqianliaohao',
					prop: 'no'
				}, {
					label: 'jiliangdanwei',
					prop: 'unit'
				}, {
					label: 'baozhuangfangshi',
					prop: 'pack'
				}, {
					label: 'maozhong(g)',
					prop: 'grossWeight'
				}, {
					label: 'jingzhong(g)',
					prop: 'netWeight'
				}, {
					label: 'miaoshu',
					prop: 'describe'
				}, {
					label: 'chuangjianshijian',
					prop: 'createTime',
					type: 'time',
				}, {
					label: 'xiugaishijian',
					prop: 'updateTime',
					type: 'time',
				}]
			}
		},
		created() {
			setTimeout(() => {
				// this.yt.conditions = {
				// 	bomId: this.$attrs.check.id,
				// 	pageNum: 1,
				// 	pageSize: 100
				// }
				this.yt.get(1);
				this.yt.isShowPagination = false;
			}, 300)

		},
		methods: {
			// beforeAdd(params, url) {
			// 	params.bomId = this.$attrs.check.id
			// 	return params
			// },
		}
	}
</script>

<style scoped lang="scss">

</style>
